import axios from 'axios'
// config
import { HOST_API } from 'src/config-global'
import { useAuthStore } from 'src/store/auth'

// ----------------------------------------------------------------------

const axiosInstance = axios.create({ baseURL: HOST_API })

axiosInstance.interceptors.request.use(
  async (config) => {
    const { token } = useAuthStore.getState()
    if (token) {
      config.headers.set('Authorization', `Bearer ${token}`)
    }
    return config
  },
  (error) => Promise.reject(error),
)

// O interceptor NUNCA desloga o usuario automaticamente. Qualquer fluxo de
// logout (token invalido, expirado, etc) e centralizado no AuthProvider para
// evitar que 401s transitorios (refetchs em background, oscilacoes de rede)
// derrubem a sessao do usuario.
axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    const isNetworkError = !error.response
    if (isNetworkError) {
      return Promise.reject(new Error('Sem conexão com o servidor. Verifique sua internet.'))
    }

    const errData = error.response?.data
    const errMsg = typeof errData === 'string' ? errData : errData?.message || 'Erro no servidor'
    return Promise.reject(new Error(errMsg))
  },
)
export default axiosInstance

export const API_ENDPOINTS = {
  auth: {
    me: '/users/me',
    login: '/auth/login',
    register: '/users',
    forgot: '/forgot',
  },
  user: {
    editMe: '/users/me',
    editPhoto: '/user/me/upload',
  },
}
